/**
 * Platform identity. Every surface that shows a name, a version or a copyright
 * line reads it from here — the API's `/platform` response, the panel's sidebar
 * footer, the page `<title>`, and the About card in Settings.
 */
export const PLATFORM = {
  /*
   * ! `key` НЬ ТАНИГЧ, ХАРАГДАХ НЭР БИШ — бүү орчуул, бүү сольж бич.
   * ! Харагдах бүх мөр (`name`, `vendor`, `copyright`) доор.
   */
  key: 'coresoft-platform',
  name: 'Maximus Platform',
  /** Semver. `displayVersion` is what a person sees; keep them in step. */
  version: '2.1.0',
  displayVersion: 'V2.1',
  vendor: 'Maximus',
  vendorUrl: 'https://maximus.mn',
  copyright: `© ${new Date().getFullYear()} Maximus.mn`,
  description: 'Модулиар угсрагддаг, эрхэд суурилсан удирдлагын платформ.',
} as const

/** "Maximus Platform V2.1" — the string for a title bar or an about box. */
export const platformTitle = (): string => `${PLATFORM.name} ${PLATFORM.displayVersion}`
